/* eslint-disable eqeqeq */
export default {
    alert(isDisabled, index) {
        if (!isDisabled || !this.$store.state.product.controls) return

        let drills = null
        if (index === undefined && this.$store.state.product.controls.drills) {
            drills = this.$store.state.product.controls.drills
        } else if (
            this.$store.state.product.controls.groups &&
            this.$store.state.product.controls.groups[index]
        ) {
            drills = this.$store.state.product.controls.groups[index].drills
        } else return

        drills.forEach((drill) => {
            if (drill.currentValue == -1 && !drill.isDisabled) {
                const scrollTarget =
                    index !== undefined
                        ? `scrollTarget-${index}-${drill.type}`
                        : `scrollTarget-${drill.type}`

                if (!document.getElementById(scrollTarget)) return

                const didScroll = this.$scrollTo('#' + scrollTarget, 50, {
                    easing: 'ease-in-out',
                    offset: -50, // Give some padding at the top of the input
                    cancelable: false, // Prevents the scroll from being cancelled by double clicks or something
                    force: false, // Will only scroll if element is NOT in view
                    onDone: () => {
                        flashIt(scrollTarget)
                    },
                })

                // If element is on the page it won't scroll, so just flash
                if (didScroll === undefined) flashIt(scrollTarget)
            }
        })
    },
}

/**
 * Blink the Blue Highlight red with no tweening transition
 * @param {Object} target - Container Element that has a -needsSelection class within it
 */
function flashIt(target) {
    // Find the -needsSelection class from within our container target
    const container = document.getElementById(target)
    if (!container) return
    const needsSelection = container.getElementsByClassName('-needsSelection')[0]
    // Found bug where sometimes needsSelection will be undefined
    if (!needsSelection) return

    // Remove the Blue highlight
    needsSelection.classList.remove('-needsSelection')
    // Set alert Red state
    needsSelection.classList.add('alert')
    let i = 0
    // Toggle the Red Alert state on/off 3 times then revert to Blue State
    const flash = setInterval(() => {
        needsSelection.classList.remove('alert')
        const alert = setTimeout(() => {
            needsSelection.classList.add('alert')
        }, 150)

        if (i == 3) {
            clearInterval(flash)
            clearTimeout(alert)
            needsSelection.classList.remove('alert')
            needsSelection.classList.add('-needsSelection')
        }
        i++
    }, 400)
}
